import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type NOM_218_SCFI_2017Props = {};

const NOM_218_SCFI_2017: React.FC<NOM_218_SCFI_2017Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='NOM-218-SCFI-2017'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col md:flex-row items-start justify-center">
          <div className="flex flex-col w-full md:w-1/2 lg:w-3/5 pt-0 md:pt-6 pb-10 md:pb-0 gap-10 pr-10">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                NOM-218-SCFI-2017
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "term_equipment",
                    defaultMessage: "Digital interface to public networks (Digital interface at 2 048 KBIT/S and 34 368 KBIT/S)"
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "radio_interface_equipment",
                    defaultMessage: "The products covered by this Official Mexican Standard are all radio communication equipment that has a digital interface to public telecommunications networks (Digital interface at 2,048 kbit/s and 34,368 kbit/s)."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'products_terminal_example',
                    defaultMessage: "Examples of equipment subject to compliance with the NOM:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "equip_e1_e3",
                    defaultMessage: "Equipment with digital interface E1 and E3"
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-2/5">
            <img src="/img/nic.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NOM_218_SCFI_2017;